import TaxCell from '@nile/client_management/src/Pages/Invoice/TaxCell';
import MultilineCell from '@nile/client_management/src/Pages/Invoice/MultilineCell';
import ServiceItemCell from '@nile/client_management/src/Pages/Invoice/ServiceItemCell';
import TextEditCell from '@nile/client_management/src/Pages/Invoice/TextEditCell';
import CurrencyCell from '@nile/client_management/src/Pages/Invoice/CurrencyCell';
import DeleteCell from '@nile/client_management/src/Pages/Invoice/DeleteCell';
import {
  EditableDateTimeCell,
  DateTimeCell
} from '@nile/mangifera/src/Components/Ticket';
import { memo } from 'react';

const invoiceDefaultColumnCells = {
  Currency: memo(CurrencyCell),
  Tax: memo(TaxCell),
  Multiline: memo(MultilineCell),
  ServiceItem: memo(ServiceItemCell),
  TextEdit: memo(TextEditCell),
  ItemDelete: memo(DeleteCell),
  DateTime: memo(EditableDateTimeCell)
};

const quoteDefaultColumnCells = {
  ...invoiceDefaultColumnCells,
  DateTime: memo(DateTimeCell)
};

export { invoiceDefaultColumnCells, quoteDefaultColumnCells };
